import type { ServiceArea } from "@/content/types";

export const SERVICE_AREAS: ServiceArea[] = [
  {
    key: "houston-tx",
    label: "Houston, Texas",
    description: [
      "As one of Texas's largest business hubs, Houston demands a CPA firm that understands the pace, diversity, and complexity of its economy. Orsak CPA's partners with companies and individuals across the city-from Downtown and the Energy Corridor to the Galleria and beyond-to deliver accurate accounting, audit, and advisory services you can rely on.",
      "Whether you're an established enterprise or a growing startup, our Houston-based team combines regional insight with big-firm experience to help you navigate every financial challenge with confidence.",
    ],
    image: {
      publicId: "houston-texas",
      alt: "Aerial view of the Houston skyline at dusk",
    },
  },
  {
    key: "texas",
    label: "Texas",
    description: [
      "Orsak CPA's proudly serves clients across the entire state of Texas, offering comprehensive accounting, tax, and advisory solutions designed around state-specific regulations and industry needs. From energy and construction to healthcare and professional services, our expertise extends across the state's most vital sectors.",
      "Whether you're in Austin, Dallas, San Antonio, or a smaller Texas community, we bring consistent professionalism and precision to every engagement-delivering the clarity and compliance your business deserves.",
    ],
    image: {
      publicId: "texas-statewide",
      alt: "Minimal Texas state outline on a neutral background",
    },
  },
  {
    key: "gulf-coast",
    label: "Gulf Coast Region",
    description: [
      "Spanning from Corpus Christi to New Orleans, the Gulf Coast region is a thriving economic corridor built on industry, energy, and innovation. Orsak CPA's supports the individuals and organizations that power this region with tailored financial oversight, tax planning, and audit services.",
      "Our team understands the regional challenges of coastal operations-whether it's compliance for energy firms or strategic advisory for service-based businesses-and provides the trusted expertise needed to grow sustainably across the Gulf Coast.",
    ],
    image: {
      publicId: "gulf-coast-region",
      alt: "Aerial coastline view representing the Gulf Coast region",
    },
  },
  {
    key: "greater-houston-area",
    label: "Greater Houston Area",
    description: [
      "Beyond the city limits, Orsak CPA's serves clients throughout the Greater Houston Area-including Sugar Land, The Woodlands, Katy, Pearland, and other fast-growing communities. We understand that local businesses require both proximity and reliability in their financial partners.",
      "From family-owned operations to regional enterprises, our firm provides dependable accounting, audit, and advisory services rooted in professionalism and long-term client relationships.",
    ],
    image: {
      publicId: "greater-houston-area",
      alt: "Stylized map indicating Greater Houston suburbs",
    },
  },
];

export const SERVICE_AREAS_BY_KEY = Object.fromEntries(
  SERVICE_AREAS.map(serviceArea => [serviceArea.key, serviceArea]),
);
